import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { IngestionEditForm } from "./components/IngestionEditForm";

export function EditIngestionPage() {
  return (
    <LqsPage title="Edit Ingestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <IngestionEditForm />
      </Container>
    </LqsPage>
  );
}
